import { createApi } from 'unsplash-js'

export const unsplash = createApi({
  //accessKey: 'WCLt1ht42OWnjcUrcRfWcmOu41ssVDtxRnob4M5MW6s'
  accessKey: 'q93ZjI-qKZUAC2EXBG9dltFMuXTSx1_mk0-9OfNGngE',
})
